(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/menu/menu.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/menu/menu.js');
"use strict";


const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
const menuItems = svs.ticket_partner.constants.menuItems;
const {
  useLocation
} = ReactRouterDOM;
const {
  LOGIN
} = svs.ticket_partner.constants.routes || {};
const Menu = _ref => {
  let {
    isLoggedIn = false,
    logout = () => {}
  } = _ref;
  const location = useLocation();
  return React.createElement(ItemsMenu, {
    branding: "neutral",
    centered: true,
    className: "items-menu-link-item-corp-demo",
    hiddenScrollbar: true,
    useScrollFaders: true,
    useScrollHelpers: true
  }, menuItems.map(item => {
    var _item$subUrls;
    const href = svs.core.data.baseUrl + item.url;
    return React.createElement(LinkItem, {
      Component: "a",
      href: href,
      key: href,
      label: item.displayName,
      onClick: () => {},
      selected: location.pathname === item.url || ((_item$subUrls = item.subUrls) === null || _item$subUrls === void 0 ? void 0 : _item$subUrls.includes(location.pathname))
    });
  }), isLoggedIn ? React.createElement(LinkItem, {
    label: "Logga ut",
    onClick: logout
  }) : React.createElement(LinkItem, {
    Component: "a",
    href: svs.core.data.baseUrl + LOGIN,
    label: "F\xF6retagsinloggning"
  }));
};
svs.ticket_partner.sharedComponents.menu.Menu = Menu;

 })(window);